var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Box, CircularProgress, makeStyles } from "@material-ui/core";
export const FTLLoader = (_a) => {
    var { color } = _a, boxProps = __rest(_a, ["color"]);
    const classes = useStyles({ color });
    return (React.createElement(Box, Object.assign({ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", width: "100%" }, boxProps),
        React.createElement(CircularProgress, { className: classes.progress })));
};
const useStyles = makeStyles((theme) => ({
    progress: ({ color = "dark" }) => ({
        color: color !== "inherit" ? theme.palette.loader[color] : "inherit",
    }),
}));
//# sourceMappingURL=index.js.map